const KEY = "jwt";

export type JwtPayload = {
  sub: string;
  role: "admin" | "viewer";
  iat: number;
  exp: number;
};

function b64urlDecode(s: string): string {
  s = s.replace(/-/g, "+").replace(/_/g, "/");
  while (s.length % 4) s += "=";
  return atob(s);
}

export function decodeJwt(token: string): JwtPayload | null {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    const json = b64urlDecode(parts[1]!);
    return JSON.parse(json) as JwtPayload;
  } catch {
    return null;
  }
}

export function setJwt(token: string): void {
  localStorage.setItem(KEY, token);
}

export function clearJwt(): void {
  localStorage.removeItem(KEY);
}

export function getValidJwt(): string | null {
  const token = localStorage.getItem(KEY);
  if (!token) return null;
  const payload = decodeJwt(token);
  if (!payload) {
    clearJwt();
    return null;
  }
  const now = Math.floor(Date.now() / 1000);
  if (payload.exp <= now) {
    clearJwt();
    return null;
  }
  return token;
}

export function getRole(): "admin" | "viewer" | null {
  const token = getValidJwt();
  if (!token) return null;
  const p = decodeJwt(token);
  return p?.role ?? null;
}
